import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import {
  IOnboardingMetadata,
  ICompanyOnboardingData,
} from '@core/entities/companyOnboarding'
import { CompanyOnboardingRequestTypes } from './requestTypes'
import { createQueryKeyString } from '@core/react-query/queryParams'

const companyOnboardingQueryKeys = createQueryKeys('company-onboarding', {
  metadata: ({
    organisationId,
  }: CompanyOnboardingRequestTypes['getOnboardingMetadata']) => {
    return {
      queryKey: [{ organisationId }],
      queryFn: async (): Promise<IOnboardingMetadata> => {
        const { data } = await APIAxiosInstance.get(
          `organisations/${organisationId}/companies/onboarding/metadata`,
        )
        return data
      },
    }
  },
  onboardingData: ({
    organisationId,
  }: CompanyOnboardingRequestTypes['getCompanyOnboardingData']) => {
    return {
      queryKey: [{ organisationId }],
      queryFn: async (): Promise<ICompanyOnboardingData> => {
        const { data } = await APIAxiosInstance.get(
          `organisations/${organisationId}/companies/onboarding`,
        )
        return data
      },
    }
  },
})

const companyOnboardingMutationKeys = createMutationKeys('company-onboarding', {
  userSelfRegister: {
    mutationKey: null,
    mutationFn: async ({
      organisationId,
      ...rest
    }: CompanyOnboardingRequestTypes['userSelfRegister']) => {
      const { data } = await APIAxiosInstance.post(
        `organisations/${organisationId}/companies/onboarding/user-self-register`,
        rest,
      )
      return data
    },
  },
  submitOnboarding: {
    mutationKey: null,
    mutationFn: async ({
      organisationId,
      ...rest
    }: CompanyOnboardingRequestTypes['submitCompanyOnboarding']) => {
      const { data } = await APIAxiosInstance.post(
        `organisations/${organisationId}/companies/onboarding`,
        rest,
      )
      return data
    },
  },
  editOnboarding: {
    mutationKey: null,
    mutationFn: async ({
      organisationId,
      companyId,
      ...rest
    }: CompanyOnboardingRequestTypes['editCompanyOnboarding']) => {
      const queryParams = createQueryKeyString({
        companyId,
      })
      const { data } = await APIAxiosInstance.put(
        `organisations/${organisationId}/companies/onboarding${queryParams}`,
        rest,
      )
      return data
    },
  },
})

export const companyOnboardingKeys = mergeQueryKeys(
  companyOnboardingQueryKeys,
  companyOnboardingMutationKeys,
)['company-onboarding']
